import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import SearchIcon from '@material-ui/icons/Search';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';

const CreditList = props => {
    const { classes, credits, dateStartCredits, dateEndCredits, handleDateStart, handleDateEnd, findDataRange, loading } = props
        return (
                <React.Fragment>
                 <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={3}  >
                            <Grid  item>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <KeyboardDatePicker
                                        // disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-start"
                                        label="Fecha de inicio"
                                        value={dateStartCredits}
                                        onChange={handleDateStart}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid  item>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <KeyboardDatePicker
                                        // disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-end"
                                        label="Fecha de fin"
                                        value={dateEndCredits}
                                        onChange={handleDateEnd}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item >
                                <Button 
                                variant="contained"
                                color="primary"
                                onClick = { () =>  findDataRange() }
                                style= {{ backgroundColor:'#00a0af'}}
                                endIcon={<SearchIcon/>}
                                >
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br/>
                {
                }
                <MaterialTable
                    title={''}
                    columns={[
                        { title: 'No', field: 'NumeroCuota' },
                        { title: 'Vencimiento', field: 'FechaVencimiento' },
                        { title: 'Saldo Capital', field: 'SaldoCapital' },
                        { title: 'Saldo Cuota', field: 'TotalCuota' },
                        { title: 'Valor Cuota', field: 'TotalCuota' },
                        { title: 'Cuota Capital', field: 'Capital' },
                        { title: 'Otros', field: 'Otros' },
                        { title: 'Interés', field: 'Interes' },
                        { title: 'Estado', field: 'Estado' },
                        { title: 'Último Pago', field: 'FechaDePago' },
                    ]}
                    options = {
                        {
                            search: false
                        }
                    }
                    isLoading= {loading}
                    data={ credits }
                    localization = {
                        {
                            body: {
                                emptyDataSourceMessage: 'No existen registros ',
                                filterRow: {
                                    filterTooltip: 'Filter'
                                }
                            }
                        }
                    } />
                <div className={classes.seeMore}>
                </div>
                </React.Fragment>
        );
};

CreditList.propTypes = {
    handleDateEnd: PropTypes.func.isRequired,
};

export default CreditList;